var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 240,
    viewBox: "0 0 201 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.81 49.25C134.343 49.2447 129.101 47.0704 125.235 43.2046C121.369 39.3387 119.195 34.097 119.19 28.6299V1.85854e-06H27.0601C23.5253 -0.00131167 20.0249 0.693646 16.7589 2.04541C13.4929 3.39718 10.5252 5.37922 8.02527 7.87818C5.52538 10.3771 3.54231 13.3441 2.18933 16.6096C0.836352 19.8751 0.140014 23.3752 0.140015 26.9099V189.13C0.140014 192.665 0.836352 196.165 2.18933 199.43C3.54231 202.696 5.52538 205.663 8.02527 208.162C10.5252 210.661 13.4929 212.643 16.7589 213.994C20.0249 215.346 23.5253 216.041 27.0601 216.04H137.66C144.797 216.04 151.642 213.205 156.688 208.158C161.735 203.112 164.57 196.267 164.57 189.13V49.25H139.81Z",
    fill: "#0072FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.57 49.25H139.81C134.343 49.2447 129.101 47.0704 125.235 43.2046C121.369 39.3387 119.195 34.097 119.19 28.6299V0L164.57 49.25Z",
    fill: "#0072FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.09 170.61H59.05C50.1803 170.61 42.99 177.8 42.99 186.67V223.95C42.99 232.82 50.1803 240.01 59.05 240.01H184.09C192.96 240.01 200.15 232.82 200.15 223.95V186.67C200.15 177.8 192.96 170.61 184.09 170.61Z",
    fill: "#0072FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/UNKNOWN.a0c123393065d4703609d735290a7ee4.svg";
export { ForwardRef as ReactComponent };